const faqs = [
  {
    q: '八戒影视网真的完全免费吗？',
    a: '是的，八戒影视网所有影视资源完全免费开放，无需注册账号、无需付费订阅、无需购买VIP会员。我们通过技术优化降低运营成本，让每一位用户都能享受零门槛的高清观影体验。',
  },
  {
    q: '播放时会不会有广告或弹窗？',
    a: '八戒影视致力于提供纯净的观影环境，页面清爽简洁，不会出现弹窗广告或强制观看的贴片广告，让您专注于内容本身，享受不被打扰的观影时光。',
  },
  {
    q: '支持哪些设备观看？需要下载APP吗？',
    a: '八戒影视采用响应式网页设计，全面适配手机、平板和电脑端，无需下载任何APP或插件，打开浏览器输入网址即可直接观看。支持iOS、Android、Windows、macOS等主流操作系统。',
  },
  {
    q: '影片画质如何？能看高清吗？',
    a: '全站资源默认提供1080P高清画质，部分热门影片支持4K超清。采用H.265高效视频编码技术，在保证清晰度的同时大幅降低流量消耗，让您在移动网络下也能流畅观看高清内容。',
  },
  {
    q: '资源更新速度怎么样？能看最新剧集吗？',
    a: '我们拥有专业的资源同步团队，热门电视剧和综艺通常在播出后24小时内更新上线，动漫新番同步日本播出时间更新。每日都有大量新资源入库，确保您不错过任何精彩内容。',
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[800px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2 text-center">
          常见问题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">关于八戒影视，你可能想了解的都在这里</p>
        <div className="space-y-3">
          {faqs.map((f, i) => (
            <div
              key={i}
              className="rounded-2xl bg-background-50 border border-background-200/70 p-5 md:p-6"
            >
              <h3 className="text-base font-heading font-bold text-foreground-900 mb-2 flex items-start gap-3">
                <span className="text-primary-500 flex-shrink-0">Q</span>
                {f.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-7">{f.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}